import _ from 'lodash'
import METRIC_KEYS from '@/models/METRIC_KEYS'

/**
 * @type {MetricsVuexState}
 */
const initialState = {

    /** @type {Array<MetricsVuexStateData>} **/
    data: [
        { key: METRIC_KEYS.fuelBill, current: 0, projected: 0 },
        { key: METRIC_KEYS.carbonSaving, current: 0, projected: 0 },
        { key: METRIC_KEYS.sapScore, current: 0, projected: 0 },
    ],

    loaded: false,
    loading: false,
    notAppliedImprovements: [],
}

/**
 * @type {MetricsVuexState}
 */
const state = _.cloneDeep(initialState)

export { initialState }

export default state
